import React, { useState, useEffect } from 'react'
import whatsapp from 'assets/icons/whatsapp.svg'

const data = {
  number: '5543998255439',
  message: 'Olá, gostaria de agendar uma consultoria',
}

function Whatsapp() {
  return (
    <button className='animate-scale-up fixed bottom-4 right-4 z-30 transition-all duration-500 hover:scale-110 md:bottom-6 md:right-6'>
      <a
        href={`https://api.whatsapp.com/send?phone=${data.number}&text=${encodeURIComponent(data.message)}`}
        target='_blank'
        rel='noopener noreferrer'
      >
        <picture>
          <img src={whatsapp} alt='Whatsapp' className='h-20 w-20' />
        </picture>
      </a>
    </button>
  )
}

export default Whatsapp
